import {
  // find as _find,
  findIndex as _findIndex,
  reduce as _reduce,
  forEach as _forEach,
  filter as _filter,
} from 'lodash';

import { DATA_ID_FULFILLED } from 'actions/DataIdActions';
import {
  CHATTER_OPEN,
  CHATTER_CLOSE,
  OPEN_CONVERSTATION,
  CLOSE_CONVERSTATION,
  DISCARD_CONVERSTATION,
  CONVERSATION_ENDED,
  CLOSE_CHATTER_REVIEW,
} from 'actions/ChatterActions';
import { SOCKET_CONNECTED, SOCKET_DISCONNECTED, SOCKET_EVENT, SOCKET_EMIT } from 'actions/SocketActions';
import { WEBRTCCALL_ENDED } from 'actions/WebRTCCallActions';
import { LIST_FULFILLED } from 'actions/ListActions';
import { FORM_FINISHED } from 'actions/FormStatusActions';

const defaultConversationState = {
  username: null,
  messages: [],
  oldest: null,
  pending: false,
  hasMoreHistory: null,
  length: 0,
  noHistory: false,
  isAnonymousUser: false,
  customerChatId: null,
  customerVideoChatId: null,
  showInactivityWarning: false,
};

const initialState = {
  connected: false,
  open: false,
  isAgent: false,
  activeConversationWith: null,
  activeConversations: [],
  unopenedMessagesFrom: {},
  leaveReview: false,
  reviewData: null,
};

export default function chatter(state = initialState, action) {
  switch (action.type) {
    case SOCKET_CONNECTED: {
      return { ...state, connected: true };
    }

    case SOCKET_DISCONNECTED: {
      return { ...state, connected: false, isAgent: false };
    }

    case CHATTER_OPEN: {
      return { ...state, open: true };
    }

    case CHATTER_CLOSE: {
      return { ...state, open: false };
    }

    case OPEN_CONVERSTATION: {
      if (action.payload) {
        const chatUser = action.payload;
        const activeConversations = state.activeConversations.slice();
        if (_findIndex(activeConversations, ['username', chatUser.id]) === -1) {
          activeConversations.push({
            ...defaultConversationState,
            username: chatUser.id,
            isAnonymousUser: chatUser.is_anonymous_user || false,
            customerChatId: chatUser.customer_chat_id || null,
            customerVideoChatId: chatUser.customer_video_chat_id || null,
          });
        }

        const unopenedMessagesFrom = { ...state.unopenedMessagesFrom };
        if (unopenedMessagesFrom[chatUser.id]) {
          unopenedMessagesFrom[chatUser.id] = undefined;
        }

        return {
          ...state,
          open: true,
          activeConversationWith: chatUser.id,
          activeConversations,
          unopenedMessagesFrom,
        };
      }
      break;
    }

    case LIST_FULFILLED: {
      switch (action.payload.listName) {
        case 'chatUsers': {
          // when the chat users list loads, we need to check if there are any active end customer conversations
          if (action.payload.response.data.list && action.payload.response.data.list.length) {
            let newActiveConversations = false;
            const activeConversations = state.activeConversations.slice();
            _forEach(
              _filter(
                action.payload.response.data.list,
                item => item.role === 'customer' && (item.is_online || item.is_mobile_online)
              ),
              chatUser => {
                // check if there already exists an active conversation
                // if not, add the conversation to the list
                if (_findIndex(activeConversations, ['username', chatUser.id]) === -1) {
                  newActiveConversations = true;

                  activeConversations.push({
                    ...defaultConversationState,
                    username: chatUser.id,
                    isAnonymousUser: chatUser.is_anonymous_user || false,
                    customerChatId: chatUser.customer_chat_id || null,
                    customerVideoChatId: chatUser.customer_video_chat_id || null,
                  });
                }
              }
            );

            if (newActiveConversations) {
              return { ...state, activeConversations };
            }
          }

          break;
        }
      }

      break;
    }

    case CLOSE_CONVERSTATION: {
      return { ...state, activeConversationWith: null };
    }

    case DISCARD_CONVERSTATION: {
      if (action.payload) {
        const activeConversations = state.activeConversations.filter(activeConversation => {
          return activeConversation.username !== action.payload;
        });
        const activeConversationWith = state.activeConversationWith === action.payload ? null : activeConversationWith;

        return { ...state, activeConversationWith, activeConversations };
      }
      break;
    }

    case SOCKET_EVENT: {
      const { eventName, args } = action.payload;

      switch (eventName) {
        case 'message': {
          const { id, from, message } = args;

          if (args && id && from && message) {
            // the message did come from other window
            const activeConversations = state.activeConversations.slice();
            const unopenedMessagesFrom = { ...state.unopenedMessagesFrom };

            const converstationIndex = _findIndex(activeConversations, ['username', from]);
            if (converstationIndex === -1) {
              activeConversations.push({
                ...defaultConversationState,
                username: from,
                messages: [args],
                length: 1,
              });
            } else {
              const activeConversation = {
                ...activeConversations[converstationIndex],
                messages: activeConversations[converstationIndex].messages.slice(),
                showInactivityWarning: false,
              };
              activeConversation.messages.push(args);
              activeConversation.length++;

              activeConversations[converstationIndex] = activeConversation;
            }

            //
            if (!state.open || from !== state.activeConversationWith) {
              const activeConversation =
                activeConversations[converstationIndex !== -1 ? converstationIndex : activeConversations.length - 1];

              unopenedMessagesFrom[from] = _reduce(
                activeConversation.messages,
                (sum, message) => {
                  return sum + (message.creator === from && (!message.status || message.status === 'unseen') ? 1 : 0);
                },
                0
              );
            }

            return { ...state, activeConversations, unopenedMessagesFrom };
          }
          break;
        }

        // an end customer wants to chat / have a video call
        case 'new_customer': {
          const { customerChat, customerVideoChat, username, isAnonymousUser } = args;
          const activeConversations = state.activeConversations.slice();

          const converstationIndex = _findIndex(activeConversations, ['username', username]);
          if (converstationIndex === -1) {
            activeConversations.push({
              ...defaultConversationState,
              username,
              isAnonymousUser,
              customerChatId: customerChat || null,
              customerVideoChatId: customerVideoChat || null,
            });
          } else {
            activeConversations[converstationIndex] = {
              ...activeConversations[converstationIndex],
              customerChatId: customerChat || null,
              customerVideoChatId: customerVideoChat || null,
              showInactivityWarning: false,
            };
          }

          return { ...state, activeConversations };
        }

        case 'self_message': {
          const { id, from, to, message } = args;

          if (args && id && from && message) {
            // the message did come from other window
            const { activeConversations } = state;

            const converstationIndex = _findIndex(activeConversations, ['username', to]);
            if (converstationIndex !== -1) {
              const activeConversation = {
                ...activeConversations[converstationIndex],
                messages: activeConversations[converstationIndex].messages.slice(),
                showInactivityWarning: false,
              };
              activeConversation.messages.push({ ...args, owner: from });
              activeConversation.length++;

              activeConversations[converstationIndex] = activeConversation;
            }

            return { ...state, activeConversations };
          }

          break;
        }

        // user got a warning that the chat will be closed in two minutes
        case 'chat_inactivity_warning': {
          const { from } = args; // from tells us who sent this warning

          if (args && from) {
            // the message did come from other window
            const { activeConversations } = state;

            const converstationIndex = _findIndex(activeConversations, ['username', from]);
            if (converstationIndex !== -1) {
              const activeConversation = {
                ...activeConversations[converstationIndex],
                showInactivityWarning: true,
              };

              activeConversations[converstationIndex] = activeConversation;
            }

            return { ...state, activeConversations };
          }

          break;
        }
      }

      break;
    }

    case SOCKET_EMIT: {
      const { eventName, args } = action.payload;

      switch (eventName) {
        case 'message': {
          const { to, message } = args;
          const converstationIndex = _findIndex(state.activeConversations, ['username', to]);

          if (to && message && converstationIndex > -1) {
            const activeConversations = state.activeConversations.slice();

            const activeConversation = {
              ...activeConversations[converstationIndex],
              messages: activeConversations[converstationIndex].messages.slice(),
              showInactivityWarning: false,
            };
            activeConversation.messages.push({ message });
            activeConversation.length++;

            activeConversations[converstationIndex] = activeConversation;

            return { ...state, activeConversations };
          }

          break;
        }

        case 'activate_agent': {
          return { ...state, isAgent: true };
        }

        case 'deactivate_agent': {
          return { ...state, isAgent: false };
        }

        // check that we initaite an active conversation if we accept an audio or video call
        case 'videocall_accepted':
        case 'call_accepted': {
          const { from, fromName, isAnonymousUser, customerChat, customerVideoChat } = args;

          if (from && fromName) {
            const activeConversations = state.activeConversations.slice();
            const converstationIndex = _findIndex(activeConversations, ['username', from]);

            if (converstationIndex === -1) {
              activeConversations.push({
                ...defaultConversationState,
                username: from,
                isAnonymousUser,
                customerChatId: customerChat || null,
                customerVideoChatId: customerVideoChat || null,
              });
            }

            return { ...state, activeConversations, activeConversationWith: from };
          }

          break;
        }
      }

      break;
    }

    case DATA_ID_FULFILLED: {
      if (!action.payload.response || !action.payload.response.data) return state;

      if (action.payload.dataIdName === 'chatterHistory' && action.payload.dataIdId) {
        const username = action.payload.dataIdId;
        const messages = action.payload.response.data.list;

        const { activeConversations } = state;
        const converstationIndex = _findIndex(activeConversations, ['username', username]);

        if (converstationIndex > -1) {
          if (messages.length) {
            const activeConversation = {
              ...activeConversations[converstationIndex],
              messages: messages.reverse().concat(activeConversations[converstationIndex].messages),
            };
            activeConversation.length += messages.length;

            const oldest = new Date(messages[0].cdate); // the first is now the oldest (reverse mutates the array)
            const oldestDate =
              oldest.getUTCFullYear() +
              '-' +
              (oldest.getUTCMonth() < 9 ? '0' + (oldest.getUTCMonth() + 1) : oldest.getUTCMonth()) +
              '-' +
              (oldest.getUTCDate() < 10 ? '0' + oldest.getUTCDate() : oldest.getUTCDate());
            const oldestTime =
              (oldest.getUTCHours() < 10 ? '0' + oldest.getUTCHours() : oldest.getUTCHours()) +
              ':' +
              (oldest.getUTCMinutes() < 10 ? '0' + oldest.getUTCMinutes() : oldest.getUTCMinutes());
            activeConversation.oldest = oldestDate + ' ' + oldestTime;

            activeConversations[converstationIndex] = activeConversation;
          } else {
            // if there are no more history entries, mark that there is no more history
            activeConversations[converstationIndex].noHistory = true;
          }

          return { ...state, activeConversations };
        }
      }

      break;
    }

    case FORM_FINISHED: {
      switch (action.payload.formName) {
        // if an end user gets a new document of customer chat new, mark it as active converstation
        case 'customerVideoCallNew':
        case 'customerChatNew': {
          const { currentAgent, isAnonymousUser, customerChat, customerVideoChat } = action.payload.response.data;

          const activeConversations = state.activeConversations.slice();
          const converstationIndex = _findIndex(activeConversations, ['username', currentAgent]);

          if (converstationIndex === -1) {
            activeConversations.push({
              ...defaultConversationState,
              username: currentAgent,
              isAnonymousUser,
              customerChatId: customerChat || null,
              customerVideoChatId: customerVideoChat || null,
            });

            return { ...state, activeConversations, activeConversationWith: currentAgent };
          }

          break;
        }
      }

      break;
    }

    case CONVERSATION_ENDED: {
      const { from, myRole, customerChatId } = action.payload;

      if (myRole === 'customer') {
        const activeConversations = state.activeConversations.slice();
        const converstationIndex = _findIndex(activeConversations, ['username', from]);
        let reviewedConversation = null;

        if (converstationIndex !== -1) {
          reviewedConversation = activeConversations[converstationIndex];
          activeConversations.splice(converstationIndex, 1);
        }

        const reviewData = {
          agent: from,
          conversation: reviewedConversation,
          customerChatId,
        };

        return { ...state, activeConversations, leaveReview: true, reviewData };
      }

      break;
    }

    case WEBRTCCALL_ENDED: {
      const { ender, myRole, customerVideoCall } = action.payload;

      if (myRole === 'customer') {
        const activeConversations = state.activeConversations.slice();
        const converstationIndex = _findIndex(activeConversations, ['username', ender]);
        let reviewedConversation = null;

        if (converstationIndex !== -1) {
          reviewedConversation = activeConversations[converstationIndex];
          activeConversations.splice(converstationIndex, 1);
        }

        const reviewData = {
          agent: ender,
          conversation: reviewedConversation,
          customerVideoCallId: customerVideoCall,
        };

        return { ...state, activeConversations, leaveReview: true, reviewData };
      }
      break;
    }

    case CLOSE_CHATTER_REVIEW: {
      return { ...state, leaveReview: false, reviewData: null };
    }

    // if we update a message status in the database, make sure we change the status also in the reducer
    case 'CHATTER_CHANGE_MESSAGE_STATUS_FULFILLED': {
      const {
        data: { id, status },
      } = action.payload;

      if (state.activeConversationWith) {
        const activeConversationIndex = _findIndex(state.activeConversations, [
          'username',
          state.activeConversationWith,
        ]);

        if (activeConversationIndex > -1) {
          const activeConversation = state.activeConversations[activeConversationIndex];
          const messageIndex = _findIndex(activeConversation.messages, ['id', id]);

          if (messageIndex > -1) {
            const activeConversations = state.activeConversations.slice();
            const newActiveConversation = {
              ...activeConversation,
              messages: activeConversation.messages.slice(),
            };
            newActiveConversation.messages[messageIndex].status = status;
            activeConversations[activeConversationIndex] = newActiveConversation;

            return { ...state, activeConversations };
          }
        }
      }
      break;
    }
  }

  return state;
}
